export default __webpack_public_path__ + "static/media/right-dots.a2222b8c.svg";